module.exports = __webpack_public_path__ + "img/journey1-A.ce200f27.png";